module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    },
    model: {
      value: (_vm.filterPanel),
      callback: function($$v) {
        _vm.filterPanel = $$v
      },
      expression: "filterPanel"
    }
  }, [_c('v-expansion-panel-content', {
    key: "filterPanel",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Server Side Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter by Status",
      "multiple": "",
      "items": _vm.Statuses,
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "single-line": "",
      "hide-details": "",
      "deletable-chips": "",
      "chips": ""
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Supplier",
      "items": _vm.suppliers,
      "item-value": "key",
      "item-text": "name",
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.supplierFilter),
      callback: function($$v) {
        _vm.supplierFilter = $$v
      },
      expression: "supplierFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Engineer",
      "items": _vm.supplierFilterEngineers,
      "item-value": "key",
      "item-text": "name",
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.engineerFilter),
      callback: function($$v) {
        _vm.engineerFilter = $$v
      },
      expression: "engineerFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Chargeable",
      "items": ['Yes', 'No'],
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.chargeableFilter),
      callback: function($$v) {
        _vm.chargeableFilter = $$v
      },
      expression: "chargeableFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.dateFilterType),
      callback: function($$v) {
        _vm.dateFilterType = $$v
      },
      expression: "dateFilterType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "None",
      "value": "none"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Created",
      "value": "created"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Scheduled",
      "value": "scheduled"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Completed",
      "value": "completed"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "full-width": "",
      "max-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "value": _vm.formattedStartFilter,
            "label": "From Date",
            "readonly": "",
            "disabled": _vm.dateFilterType === 'none'
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.startFilterMenu),
      callback: function($$v) {
        _vm.startFilterMenu = $$v
      },
      expression: "startFilterMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        _vm.startFilterMenu = false
      }
    },
    model: {
      value: (_vm.startFilter),
      callback: function($$v) {
        _vm.startFilter = $$v
      },
      expression: "startFilter"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "full-width": "",
      "max-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "value": _vm.formattedEndFilter,
            "label": "To Date",
            "readonly": "",
            "disabled": _vm.dateFilterType === 'none'
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.endFilterMenu),
      callback: function($$v) {
        _vm.endFilterMenu = $$v
      },
      expression: "endFilterMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        _vm.endFilterMenu = false
      }
    },
    model: {
      value: (_vm.endFilter),
      callback: function($$v) {
        _vm.endFilter = $$v
      },
      expression: "endFilter"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("Load Jobs")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.filteredJobs.length && _vm.initialFetch) ? _c('h1', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n    No jobs meet your criteria\n  ")]) : _vm._e(), _vm._v(" "), (_vm.filteredJobs.length) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.summaryCards), function(card, i) {
    return _c('v-flex', {
      key: i
    }, [_c('v-card', {
      staticClass: "pa-2 mt-1 text-xs-center"
    }, [_c('v-progress-circular', {
      attrs: {
        "size": 70,
        "width": 10,
        "rotate": 360,
        "value": (_vm.states[i] / _vm.totalJobs) * 100,
        "color": card.color
      }
    }, [_vm._v("\n          " + _vm._s(_vm.states[i]) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(card.title))])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filteredJobs.length) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', [_c('v-switch', {
    attrs: {
      "label": "Show Finance Columns"
    },
    model: {
      value: (_vm.showFinanceColumns),
      callback: function($$v) {
        _vm.showFinanceColumns = $$v
      },
      expression: "showFinanceColumns"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exportJobs
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('bulk-update-jobs-dialog', {
    on: {
      "updateComplete": _vm.getJobs
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "rows-per-page-items": [
        25,
        50,
        100,
        {
          text: '$vuetify.dataIterator.rowsPerPageAll',
          value: -1
        } ],
      "headers": _vm.filteredHeaders,
      "items": _vm.filteredJobs,
      "search": _vm.search,
      "item-key": "id",
      "select-all": "",
      "loading": _vm.tableLoading,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.customerName) + "\n          ")]), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": _vm.updateRegV,
            "lazy": "",
            "large": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.updateRegV = $event
            },
            "update:return-value": function($event) {
              _vm.updateRegV = $event
            },
            "save": function($event) {
              return _vm.updateReg(props.item)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "value": props.item.Vehicle ?
                    props.item.Vehicle ?
                    _vm.vehicleRegFromID(props.item.Vehicle) :
                    props.item.VehicleReg :
                    props.item.vehReg
                },
                on: {
                  "change": function (v) { return (_vm.updateRegV = v); }
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1), _vm._v("\n                " + _vm._s(props.item.Vehicle ?
          props.item.Vehicle ?
          _vm.vehicleRegFromID(props.item.Vehicle) :
          props.item.VehicleReg :
          props.item.vehReg) + "\n              ")], 1)])], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("formatDate")(props.item.CreatedDate)) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("formatDate")(props.item.Date)) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("formatDate")(props.item.CompletedDate)) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.AllocatedEngineer) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.Project) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.JobNo) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("jobStatus")(props.item.Status, props.item.Allocated)) + "\n          ")]), _vm._v(" "), (_vm.showFinanceColumns) ? _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            £" + _vm._s(props.item.customerPrice) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showFinanceColumns) ? _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            £" + _vm._s(props.item.engineerCost) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showFinanceColumns) ? _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            £" + _vm._s(props.item.hardwareCost) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showFinanceColumns) ? _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.invoiced) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [(props.item.jobStarted && props.item.Status == 0) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "blue"
                }
              }, [_vm._v("account_box")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Engineer has started this job but not sent it back to portal\n                yet")])]) : _vm._e(), _vm._v(" "), (props.item.Status > 0) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [(props.item.Status > 0) ? _c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.viewJob(props.item.id)
                  }
                }
              }, on), [(props.item.Status > 2) ? _c('v-icon', {
                attrs: {
                  "color": "primary"
                }
              }, [_vm._v("assignment_turned_in")]) : (props.item.Status == 2) ? _c('v-icon', {
                attrs: {
                  "color": "success"
                }
              }, [_vm._v("assignment_ind")]) : _c('v-icon', {
                attrs: {
                  "color": "red"
                }
              }, [_vm._v("assignment_late")])], 1) : _vm._e()]
            }
          }], null, true)
        }, [_vm._v(" "), (props.item.Status > 2) ? _c('span', [_vm._v("Approved")]) : (props.item.Status == 2) ? _c('span', [_vm._v("Completed")]) : _c('span', [_vm._v("Issue")])]) : _vm._e(), _vm._v(" "), (props.item.chargeable) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [(props.item.chargeable) ? _c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "black"
                }
              }, [_vm._v("mdi-currency-gbp")])], 1) : _vm._e()]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Chargeable")])]) : _vm._e(), _vm._v(" "), (props.item.Status < 3) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [(props.item.Status < 3) ? _c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.approveJob(props.item.id)
                  }
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "green"
                }
              }, [_vm._v("check")])], 1) : _vm._e()]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Approve Job")])]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.editItem(props.item.id)
                  }
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "teal"
                }
              }, [_vm._v("edit")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Item")])]), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.deleteItem(props.item)
                  }
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "pink"
                }
              }, [_vm._v("delete")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Delete")])])], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [_c('v-card', {
          staticClass: "ma-2"
        }, [_vm._v("\n            " + _vm._s(props.item.notes) + "\n            "), _c('v-list', {
          attrs: {
            "dark": "",
            "dense": ""
          }
        }, _vm._l((props.item.templates), function(template, i) {
          return _c('v-list-tile', {
            key: i
          }, [_c('v-list-tile-action', [_c('v-checkbox', {
            attrs: {
              "disabled": "",
              "input-value": "true"
            }
          })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.templates.find(function (t) {
            return t.id === template;
          }).name))])], 1)], 1)
        }), 1)], 1)], 1)]
      }
    }], null, false, 2819367673),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('completed-view', {
    attrs: {
      "visible": _vm.viewDialog,
      "JobID": _vm.currentJob
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDialog = $event
      },
      "approveJob": _vm.approveJob,
      "issueJob": _vm.issueJob
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "90%",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formTitle))])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "info",
      "value": _vm.editedItem.Status > 1
    }
  }, [_vm._v("This job has already been completed, please only edit the job\n                if details were incorrect at time of install.")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.saveJobFailed),
      callback: function($$v) {
        _vm.saveJobFailed = $$v
      },
      expression: "saveJobFailed"
    }
  }, [_vm._v("An error occured when trying to save the job. Please try\n                again.")]), _vm._v(" "), _c('v-form', {
    ref: "newJob",
    model: {
      value: (_vm.newJobValid),
      callback: function($$v) {
        _vm.newJobValid = $$v
      },
      expression: "newJobValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Notes",
      "outline": ""
    },
    model: {
      value: (_vm.editedItem.notes),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "notes", $$v)
      },
      expression: "editedItem.notes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Vehicle",
      "items": _vm.vehicles,
      "loading": _vm.gettingVehicles,
      "item-value": "VehicleReg",
      "item-text": "VehicleReg",
      "rules": [function (v) { return !!v || 'Item is required'; }],
      "required": "",
      "clearable": ""
    },
    model: {
      value: (_vm.vehicleSelect),
      callback: function($$v) {
        _vm.vehicleSelect = $$v
      },
      expression: "vehicleSelect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Select Customer",
      "items": _vm.customerList,
      "item-text": "name",
      "item-value": "key",
      "dense": ""
    },
    model: {
      value: (_vm.editedItem.Customer),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Customer", $$v)
      },
      expression: "editedItem.Customer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Select Site",
      "items": _vm.sites,
      "item-text": "name",
      "item-value": "key",
      "hint": "What site is this vehicle at?",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: (_vm.editedItem.Site),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Site", $$v)
      },
      expression: "editedItem.Site"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Select Products",
      "items": _vm.products,
      "multiple": "",
      "chips": "",
      "item-text": "name",
      "item-value": "id",
      "hint": "What templates does this job need?",
      "persistent-hint": "",
      "deletable-chips": "",
      "dense": ""
    },
    model: {
      value: (_vm.selectProducts),
      callback: function($$v) {
        _vm.selectProducts = $$v
      },
      expression: "selectProducts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Assign to Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.supplierSelect),
      callback: function($$v) {
        _vm.supplierSelect = $$v
      },
      expression: "supplierSelect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Assign to Engineer",
      "items": _vm.supplierSelectEngineers,
      "item-text": "name",
      "item-value": "key",
      "loading": _vm.gettingEngineers,
      "clearable": ""
    },
    model: {
      value: (_vm.editedItem.Allocated),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Allocated", $$v)
      },
      expression: "editedItem.Allocated"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Assign to Project",
      "items": _vm.projects,
      "item-text": "projectId",
      "item-value": "projectId",
      "clearable": ""
    },
    on: {
      "change": _vm.setJobSupplier
    },
    model: {
      value: (_vm.editedItem.Project),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Project", $$v)
      },
      expression: "editedItem.Project"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-menu', {
    ref: "dateDialog",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "min-width": "290px",
      "return-value": _vm.editedItem.Date,
      "close-on-content-click": false
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.editedItem, "Date", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.editedItem, "Date", $event)
      }
    },
    model: {
      value: (_vm.dateDialog),
      callback: function($$v) {
        _vm.dateDialog = $$v
      },
      expression: "dateDialog"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Scheduled Date",
      "value": _vm._f("formatDate")(_vm.editedItem.Date),
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.dateDialog.save(_vm.editedItem.Date)
      }
    },
    model: {
      value: (_vm.editedItem.Date),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Date", $$v)
      },
      expression: "editedItem.Date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Chargeable",
      "items": _vm.chargeableOptions
    },
    model: {
      value: (_vm.editedItem.chargeable),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "chargeable", $$v)
      },
      expression: "editedItem.chargeable"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Finance Type",
      "items": ['Warranty', 'Chargeable', 'Unknown']
    },
    model: {
      value: (_vm.editedItem.finance.type),
      callback: function($$v) {
        _vm.$set(_vm.editedItem.finance, "type", $$v)
      },
      expression: "editedItem.finance.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prefix": "£",
      "number": "",
      "label": "Customer Price"
    },
    model: {
      value: (_vm.editedItem.finance.customerCost),
      callback: function($$v) {
        _vm.$set(_vm.editedItem.finance, "customerCost", $$v)
      },
      expression: "editedItem.finance.customerCost"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prefix": "£",
      "number": "",
      "label": "Engineer Cost"
    },
    model: {
      value: (_vm.editedItem.finance.supplierCost),
      callback: function($$v) {
        _vm.$set(_vm.editedItem.finance, "supplierCost", $$v)
      },
      expression: "editedItem.finance.supplierCost"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prefix": "£",
      "number": "",
      "label": "Hardware Cost"
    },
    model: {
      value: (_vm.editedItem.hardwareCost),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "hardwareCost", $$v)
      },
      expression: "editedItem.hardwareCost"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Job Invoiced",
      "items": ['YES', 'NO', 'N/A']
    },
    model: {
      value: (_vm.editedItem.invoiced),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "invoiced", $$v)
      },
      expression: "editedItem.invoiced"
    }
  })], 1), _vm._v(" "), (_vm.oldExtras) ? [_vm._l((_vm.editedItem.extras), function(item, index) {
    return [(item.length) ? _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "text",
        "label": index
      },
      model: {
        value: (_vm.editedItem.extras[index]),
        callback: function($$v) {
          _vm.$set(_vm.editedItem.extras, index, $$v)
        },
        expression: "editedItem.extras[index]"
      }
    })], 1) : _vm._e()]
  })] : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.oldExtras = true
      }
    }
  }, [_vm._v("Show Old Extras")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.editedItem.additionalFields), function(field, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "md2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Field Name"
      },
      model: {
        value: (field['fieldName']),
        callback: function($$v) {
          _vm.$set(field, 'fieldName', $$v)
        },
        expression: "field['fieldName']"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs7": "",
        "md4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Field Value"
      },
      model: {
        value: (field['fieldValue']),
        callback: function($$v) {
          _vm.$set(field, 'fieldValue', $$v)
        },
        expression: "field['fieldValue']"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "flat": "",
        "icon": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editedItem.additionalFields.splice(index, 1)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    ref: "additionalFieldBtn",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.addAdditionalField
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("add")]), _vm._v("Additional Field")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._l((_vm.editedItem.templateExtras), function(product) {
    return [_c('h4', {
      key: product.id
    }, [_vm._v("\n                        Product: " + _vm._s(product.product.name) + "\n                      ")]), _vm._v(" "), _vm._l((_vm.productExtras.filter(
      function (p) { return p.id === product.product.id; }
    )), function(item, index) {
      return [(_vm.editedItem.extras[product.product.id]) ? _c('v-flex', {
        key: index,
        attrs: {
          "xs12": "",
          "sm6": "",
          "md4": ""
        }
      }, [(item.type === 'choice') ? _c('v-select', {
        attrs: {
          "label": item.name,
          "items": item.options,
          "required": item.required === true,
          "clearable": item.default === '' ? true : false
        },
        model: {
          value: (
            _vm.editedItem.extras[product.product.id][item.name]
          ),
          callback: function($$v) {
            _vm.$set(_vm.editedItem.extras[product.product.id], item.name, $$v)
          },
          expression: "\n                              editedItem.extras[product.product.id][item.name]\n                            "
        }
      }) : (item.type === 'text') ? _c('v-text-field', {
        attrs: {
          "type": "text",
          "label": item.name,
          "required": item.required === true
        },
        model: {
          value: (
            _vm.editedItem.extras[product.product.id][item.name]
          ),
          callback: function($$v) {
            _vm.$set(_vm.editedItem.extras[product.product.id], item.name, $$v)
          },
          expression: "\n                              editedItem.extras[product.product.id][item.name]\n                            "
        }
      }) : _c('v-text-field', {
        attrs: {
          "type": "number",
          "step": item.step,
          "label": item.name,
          "required": item.required === true
        },
        model: {
          value: (
            _vm.editedItem.extras[product.product.id][item.name]
          ),
          callback: function($$v) {
            _vm.$set(_vm.editedItem.extras[product.product.id], item.name, $$v)
          },
          expression: "\n                              editedItem.extras[product.product.id][item.name]\n                            "
        }
      })], 1) : _vm._e()]
    }), _vm._v(" "), _vm._l((product.templateDetails), function(device) {
      return [(device.extras !== undefined) ? [_c('v-card', {
        key: device.id
      }, [_c('h5', [_vm._v("Device: " + _vm._s(device.name))]), _vm._v(" "), (device.deviceDetails) ? _c('table', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('thead', _vm._l((device.extras), function(detail) {
        return _c('th', {
          key: detail.id
        }, [_vm._v("\n                                  " + _vm._s(detail.name) + "\n                                ")])
      }), 0), _vm._v(" "), _c('tbody', _vm._l((device.extras), function(detail) {
        return _c('td', {
          key: detail.id,
          staticClass: "pa-2 text-sm-center"
        }, [_c('span', [_vm._v(_vm._s(device.deviceDetails[detail.name]))])])
      }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((device.extras), function(detail) {
        return [(
          detail.type === 'uid' &&
          !device.deviceDetails
        ) ? _c('v-autocomplete', {
          key: detail.name,
          staticClass: "mx-4 mt-2",
          attrs: {
            "box": "",
            "label": "Select Device",
            "append-outer-icon": "refresh",
            "item-value": "id",
            "return-object": "",
            "item-text": "id",
            "items": _vm.devices.filter(
              function (d) { return d.type === device.id && !d.vehicle; }
            ),
            "value": device.deviceDetails !== undefined ?
              device.deviceDetails[detail.name] :
              ''
          },
          on: {
            "change": function (v) {
              device.deviceDetails = v;
            },
            "click:append-outer": _vm.forceUpdate
          }
        }) : _vm._e()]
      })], 2)] : _vm._e()]
    })]
  })], 2)], 2)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "disabled": !_vm.newJobValid,
      "loading": _vm.savingSaveJob
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.addToProjectDialog),
      callback: function($$v) {
        _vm.addToProjectDialog = $$v
      },
      expression: "addToProjectDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline mr-4"
  }, [_vm._v("Assign Jobs to Project")]), _vm._v(" "), (!_vm.createNewProject) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.createNewProject = true
      }
    }
  }, [_vm._v("create new project?")]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.createNewProject = false
      }
    }
  }, [_vm._v("cancel new project?")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', [(_vm.createNewProject === false) ? _c('v-select', {
    attrs: {
      "label": "Assign to Project",
      "items": _vm.projects,
      "item-text": "projectId",
      "item-value": "projectId"
    },
    model: {
      value: (_vm.assignToProject),
      callback: function($$v) {
        _vm.assignToProject = $$v
      },
      expression: "assignToProject"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createNewProject === true) ? [_c('v-select', {
    attrs: {
      "label": "Project to copy",
      "items": _vm.projects,
      "item-text": "projectId",
      "item-value": "projectId"
    },
    model: {
      value: (_vm.duplicateProjectSource),
      callback: function($$v) {
        _vm.duplicateProjectSource = $$v
      },
      expression: "duplicateProjectSource"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key"
    },
    model: {
      value: (_vm.duplicateProjectSupplier),
      callback: function($$v) {
        _vm.duplicateProjectSupplier = $$v
      },
      expression: "duplicateProjectSupplier"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.duplicateProjectSource === null
    },
    on: {
      "click": _vm.createDuplicateProject
    }
  }, [_vm._v("Create New Project")])] : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Jobs to be assigned")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n              " + _vm._s(job.JobNo) + "\n            ")])
  }), 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "disabled": _vm.assignToProject === null,
      "loading": _vm.savingAddJobsToProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addJobsToProject($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addToProjectDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.issueDialog),
      callback: function($$v) {
        _vm.issueDialog = $$v
      },
      expression: "issueDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Flag Issue With Job")])]), _vm._v(" "), _c('v-card-text', [_c('h4', [_vm._v("You are about to flag an issue with job " + _vm._s(_vm.currentJobNo) + ".")]), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Notes"
    },
    model: {
      value: (_vm.JobNotes),
      callback: function($$v) {
        _vm.JobNotes = $$v
      },
      expression: "JobNotes"
    }
  })] : _vm._e()], 2), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "flat": "",
      "loading": _vm.issueingJob
    },
    nativeOn: {
      "click": function($event) {
        return _vm.issueCurrentJob($event)
      }
    }
  }, [_vm._v("Issue With Job")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.issueDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.assignToEngineerDialog),
      callback: function($$v) {
        _vm.assignToEngineerDialog = $$v
      },
      expression: "assignToEngineerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Assign Jobs to Engineer")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-autocomplete', {
    attrs: {
      "label": "Assign to Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key",
      "disabled": ""
    },
    model: {
      value: (_vm.assignToSupplier),
      callback: function($$v) {
        _vm.assignToSupplier = $$v
      },
      expression: "assignToSupplier"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Assign to Engineer",
      "items": _vm.assignToSupplierEngineers,
      "item-text": "name",
      "item-value": "key",
      "loading": _vm.gettingEngineers,
      "clearable": "",
      "disabled": !_vm.assignToSupplier
    },
    model: {
      value: (_vm.assignToEngineer),
      callback: function($$v) {
        _vm.assignToEngineer = $$v
      },
      expression: "assignToEngineer"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Jobs to be assigned")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n              " + _vm._s(job.JobNo) + "\n            ")])
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.assignToSupplier) ? _c('h5', {
    staticClass: "error--text"
  }, [_vm._v("\n            A Supplier must be assigned to the selected jobs parent project\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingAssignJobsToEngineer,
      "disabled": !_vm.assignToSupplier
    },
    nativeOn: {
      "click": function($event) {
        return _vm.assignJobsToEngineer($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.assignToEngineerDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.deleteJobsDialog),
      callback: function($$v) {
        _vm.deleteJobsDialog = $$v
      },
      expression: "deleteJobsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Delete Jobs")])]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("You are about to delete these jobs")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n            " + _vm._s(job.JobNo) + "\n          ")])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": "",
      "loading": _vm.deletingJobs
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteMultiJobs($event)
      }
    }
  }, [_vm._v("Delete Jobs")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteJobsDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.approveJobsDialog),
      callback: function($$v) {
        _vm.approveJobsDialog = $$v
      },
      expression: "approveJobsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Approve Jobs")])]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("You are about to approve these jobs")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n            " + _vm._s(job.JobNo) + "\n          ")])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "flat": "",
      "loading": _vm.approvingJobs
    },
    nativeOn: {
      "click": function($event) {
        return _vm.approveMultiJobs($event)
      }
    }
  }, [_vm._v("Approve Jobs")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.approveJobsDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.approveDialog),
      callback: function($$v) {
        _vm.approveDialog = $$v
      },
      expression: "approveDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Approve Job")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Update Vehicle Reg"
    },
    model: {
      value: (_vm.approvalReg),
      callback: function($$v) {
        _vm.approvalReg = $$v
      },
      expression: "approvalReg"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("You are about to approve job " + _vm._s(_vm.currentJobNo) + ".")]), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? [_c('h5', [_vm._v("Job Attachments")]), _vm._v(" "), _vm._l((_vm.jobs.find(function (job) {
    return job.id === this$1.currentJob;
  }).completedDocs), function(doc) {
    return _c('v-list-tile', {
      key: doc.name
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "href": doc.downloadUrl,
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
  })] : _vm._e(), _vm._v(" "), _c('upload-btn', {
    ref: "btnAttachCompletedFile",
    attrs: {
      "multiple": true,
      "title": 'Attach New Document',
      "fileChangedCallback": _vm.attachCompletedFile
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-paperclip")])], 1)], 2), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.fileProgress === 100 ? 'success' : 'primary',
      "value": _vm.fileProgress
    }
  })], 2), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "flat": "",
      "loading": _vm.approvingJob,
      "disabled": _vm.jobs.find(function (job) {
          return job.id === this$1.currentJob;
        }).Status < 1 &&
        !_vm.jobs.find(function (job) {
          return job.id === this$1.currentJob;
        }).completedDocs
    },
    nativeOn: {
      "click": function($event) {
        return _vm.approveCurrentJob($event)
      }
    }
  }, [_vm._v("Approve Job")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.approveDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-speed-dial', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected.length > 0),
      expression: "selected.length > 0"
    }],
    attrs: {
      "bottom": "",
      "right": "",
      "fixed": ""
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": "",
      "fab": "",
      "hover": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "pink"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.deleteJobsDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Delete")])], 1), _vm._v(" "), (_vm.selectedSameProject) ? _c('v-tooltip', {
    attrs: {
      "color": "indigo",
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "indigo"
    },
    on: {
      "click": function($event) {
        _vm.assignToEngineerDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('span', [_vm._v("Assign Engineer")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "orange"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "orange"
    },
    on: {
      "click": function($event) {
        _vm.addToProjectDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("library_add")])], 1), _vm._v(" "), _c('span', [_vm._v("Change Project")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "green"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        _vm.approveJobsDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve Jobs")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "yellow"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "yellow"
    },
    on: {
      "click": _vm.printSelectedJobs
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('span', [_vm._v("Print")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.tableLoading),
      callback: function($$v) {
        _vm.tableLoading = $$v
      },
      expression: "tableLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Fetching Data\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32589cb3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jobs.vue
// module id = 741
// module chunks = 1